import { gql } from '@apollo/client';

export const FETCH_BIRTHDAY_IGNORED_CONTACTS = gql`
    query {
        user {
            unifiedContacts(ignoreBirthday: true) {
                displayName
                primaryEmail
                effectiveName
                photoImageUrl
                ignoreBirthday
                id
            }
        }
    }
`;

export const UPDATE_BIRTHDAY_IGNORED_CONTACTS = gql`
    mutation UpdateUnifiedContact($updateUnifiedContactInput: UpdateUnifiedContactInput!) {
        updateUnifiedContact(input: $updateUnifiedContactInput) {
            unifiedContact {
                id
                ignoreBirthday
              }
            errors {
                path
                message
            }
        }
    }
`;
